export const dataHooks = {
  funnelChartItem: 'funnel-chart-item',
  labelValue: 'funnel-chart-item-label-value',
  labelText: 'funnel-chart-item-label-text',
  badge: 'funnel-chart-item-badge',
  badgeValue: 'funnel-chart-item-badge-value',
  badgeTooltip: 'funnel-chart-item-badge-tooltip',
};
